import { useEffect } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Login from "./screens/authentication/Login";
import SidebarNav from "./screens/navigation/NavGlobal";
import Dashboard from "./screens/Dashdoard";
import { _ROUTER_DOM_URL } from "./utils/_routes_constants";
import { UserAdmin } from "./screens/administration/UserAdmin";
import { SetPassword } from "./screens/authentication/SetPassword";
import { NotFound } from "./screens/404";
import ActiviteAdmin from "./screens/administration/ActiviteAdmin";
import SiteAdmin from "./screens/administration/SiteAdmin";
import BasicListContextProvider from "./contexts/BasicListContext";
import { CompanyAdmin } from "./screens/administration/CompanyAdmin";
import NotAllowed from "./screens/errors_screens/NotAllowed";
import { SourceAdmin } from "./screens/administration/SourceAdmin";
import { Accounts } from "./screens/parameters/Accounts";
import { Import } from "./screens/real/Import";
import BudgetParameters from "./screens/budget/Parameters";
import InputPayrolls from "./screens/budget/InputPayrolls";
import InputRateIncrease from "./screens/budget/InputRateIncrease";
import { InputHr } from "./screens/budget/InputHr";
import InputPlumsSplitSource from "./screens/budget/InputPlumsSplitSource";
import { InputWasteRate } from "./screens/budget/InputWasteRate";
import { InputSaleFilaire } from "./screens/budget/InputSaleFilaire";
import VolumeFilaireAdmin from "./screens/administration/VolumeFilaireAdmin";
import { InputIt } from "./screens/budget/InputIt";
import { InputFleetOptimisation } from "./screens/budget/InputFleetOptimisation";
import InputDepreciation from "./screens/budget/InputDepreciation";
import InputSaleAgg from "./screens/budget/InputSaleAgg";
import { InputHireEquipment } from "./screens/budget/InputHireEquipment";
import InputSalesDepot from "./screens/budget/InputSalesDepot";
import { DataView } from "./screens/real/DataView";
import InputSaleBlock from "./screens/budget/InputSaleBlock";
import { Templates } from "./screens/indicator/Templates";
import { TemplateView } from "./screens/indicator/TemplateView";
import { InputQuarryingExcavator } from "./screens/budget/InputQuarryingExcavator";
import { InputTurnoverLrl } from "./screens/budget/InputTurnoverLrl";
import { ExportBudget } from "./screens/budget/ExportBudget";

function Page({ element, title }) {
  useEffect(() => {
    document.title = title;
  }, [title]);

  return (
    <>
      <BasicListContextProvider>{element}</BasicListContextProvider>
    </>
  );
}

export default function CustomRouter() {
  return <RouterProvider router={router} />;
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <Page title="Login" element={<Login />} />,
  },
  {
    path: _ROUTER_DOM_URL.DASHBOARD_GENERAL,
    element: (
      <Page
        element={<SidebarNav children={<Dashboard />} />}
        title="General Dashboard"
      />
    ),
  },
  {
    path: _ROUTER_DOM_URL.USERS,
    element: (
      <Page element={<SidebarNav children={<UserAdmin />} />} title="Users" />
    ),
  },
  {
    path: _ROUTER_DOM_URL.COMPANIES,
    element: (
      <Page
        element={<SidebarNav children={<CompanyAdmin />} />}
        title="Companies"
      />
    ),
  },
  {
    path: _ROUTER_DOM_URL.ACTIVITES,
    element: (
      <Page
        element={<SidebarNav children={<ActiviteAdmin />} />}
        title="Activities"
      />
    ),
  },
  {
    path: _ROUTER_DOM_URL.SITES,
    element: (
      <Page element={<SidebarNav children={<SiteAdmin />} />} title="Sites" />
    ),
  },
  {
    path: _ROUTER_DOM_URL.SOURCES,
    element: (
      <Page
        element={<SidebarNav children={<SourceAdmin />} />}
        title="Sources"
      />
    ),
  },
  {
    path: _ROUTER_DOM_URL.VOLUME_FILAIRE,
    element: (
      <Page
        element={<SidebarNav children={<VolumeFilaireAdmin />} />}
        title="Volumes filaire"
      />
    ),
  },
  {
    path: _ROUTER_DOM_URL.RESET_PASSWORD + "/:token",
    element: <Page title="Reset Password" element={<SetPassword />} />,
  },
  {
    path: _ROUTER_DOM_URL.ACCOUNT_PARAMETERS,
    element: (
      <Page title="Accounts" element={<SidebarNav children={<Accounts />} />} />
    ),
  },
  {
    path: "*",
    element: <Page title="404" element={<NotFound />} />,
  },
  {
    path: _ROUTER_DOM_URL.NOT_ALLOWED,
    element: (
      <Page
        element={<SidebarNav children={<NotAllowed />} />}
        title="Not allowed"
      />
    ),
  },
  {
    path: _ROUTER_DOM_URL.REAL_IMPORT,
    element: (
      <Page element={<SidebarNav children={<Import />} />} title="Import" />
    ),
  },
  {
    path: _ROUTER_DOM_URL.REAL_DATA,
    element: (
      <Page
        element={<SidebarNav children={<DataView />} />}
        title="Data View"
      />
    ),
  },
  {
    path: _ROUTER_DOM_URL.INDICATORS_TEMPLATES,
    element: (
      <Page
        element={<SidebarNav children={<Templates />} />}
        title="Templates"
      />
    ),
  },
  {
    path: _ROUTER_DOM_URL.INDICATORS_TEMPLATE_VIEW,
    element: (
      <Page
        element={<SidebarNav children={<TemplateView />} />}
        title="Template View"
      />
    ),
  },
  {
    path: _ROUTER_DOM_URL.BUDGET_PARAMETERS,
    element: (
      <Page
        element={<SidebarNav children={<BudgetParameters />} />}
        title="Budget Parameters"
      />
    ),
  },
  {
    path: _ROUTER_DOM_URL.BUDGET_INPUT_PAYROLL,
    element: (
      <Page
        element={<SidebarNav children={<InputPayrolls />} />}
        title="Budget Input Payrolls"
      />
    ),
  },
  {
    path: _ROUTER_DOM_URL.BUDGET_INPUT_HR,
    element: (
      <Page title="Input HR" element={<SidebarNav children={<InputHr />} />} />
    ),
  },
  {
    path: _ROUTER_DOM_URL.BUDGET_INPUT_RATE_INCREASE,
    element: (
      <Page
        title="Budget Input Rate Increase"
        element={<SidebarNav children={<InputRateIncrease />} />}
      />
    ),
  },
  {
    path: _ROUTER_DOM_URL.BUDGET_INPUT_PLUMS_SPLIT_SOURCE,
    element: (
      <Page
        element={<SidebarNav children={<InputPlumsSplitSource />} />}
        title="Budget Input Plums Split Source"
      />
    ),
  },
  {
    path: _ROUTER_DOM_URL.BUDGET_INPUT_WASTE_RATE,
    element: (
      <Page
        element={<SidebarNav children={<InputWasteRate />} />}
        title="Budget Input Waste Rate"
      />
    ),
  },
  {
    path: _ROUTER_DOM_URL.BUDGET_INPUT_SF,
    element: (
      <Page
        title="Budget Input Sale Filaire"
        element={<SidebarNav children={<InputSaleFilaire />} />}
      />
    ),
  },
  {
    path: _ROUTER_DOM_URL.BUDGET_INPUT_ITS,
    element: (
      <Page
        title="Budget Input IT"
        element={<SidebarNav children={<InputIt />} />}
      />
    ),
  },
  {
    path: _ROUTER_DOM_URL.BUDGET_INPUT_FLEET_OPTIMISATION,
    element: (
      <Page
        title="Budget Input Fleet Optimisation"
        element={<SidebarNav children={<InputFleetOptimisation />} />}
      />
    ),
  },
  {
    path: _ROUTER_DOM_URL.INPUT_DEPRECIATION,
    element: (
      <Page
        title="Budget Input Depreciation"
        element={<SidebarNav children={<InputDepreciation />} />}
      />
    ),
  },
  {
    path: _ROUTER_DOM_URL.INPUT_SALES_AGG,
    element: (
      <Page
        title="Input Sales AGG "
        element={<SidebarNav children={<InputSaleAgg />} />}
      />
    ),
  },
  {
    path: _ROUTER_DOM_URL.BUDGET_INPUT_HIRE_EQUIPMENT,
    element: (
      <Page
        title="Budget Input Hire Equipment"
        element={<SidebarNav children={<InputHireEquipment />} />}
      />
    ),
  },
  {
    path: _ROUTER_DOM_URL.INPUT_SALES_DEPOT,
    element: (
      <Page
        title="Budget Input Sales Depot"
        element={<SidebarNav children={<InputSalesDepot />} />}
      />
    ),
  },
  {
    path: _ROUTER_DOM_URL.INPUT_SALES_BLOCK,
    element: (
      <Page
        title="Budget Input Sales Block"
        element={<SidebarNav children={<InputSaleBlock />} />}
      />
    ),
  },
  {
    path: _ROUTER_DOM_URL.INPUT_QUARRIYING_EXCAVATOR,
    element: (
      <Page
        title="Budget Input Quarrying Excavator"
        element={<SidebarNav children={<InputQuarryingExcavator />} />}
      />
    ),
  },
  {
    path: _ROUTER_DOM_URL.INPUT_TURNOVER_LRL,
    element: (
      <Page
        title="Budget Input Turnover LRL"
        element={<SidebarNav children={<InputTurnoverLrl />} />}
      />
    ),
  },
  {
    path: _ROUTER_DOM_URL.EXPORT_BUDGET,
    element: (
      <Page
        title="Export Budget"
        element={<SidebarNav children={<ExportBudget />} />}
      />
    ),
  },
]);
